module.exports = __webpack_public_path__ + "static/img/call-pass.9d163d63.png";